interface Props {
  percentage: number | null
  targetType?: 'number' | 'currency' | 'percentage' | null
  currentValue?: number | null
  targetValue?: number | null
}

export default function RockProgressBar({ percentage, targetType, currentValue, targetValue }: Props) {
  if (percentage === null || percentage === undefined) {
    return <span className="text-sm text-text-muted">N/A</span>
  }

  const formatValue = (val: number | null | undefined): string => {
    if (val === null || val === undefined) return '—'
    switch (targetType) {
      case 'currency': return `$${val.toLocaleString()}`
      case 'percentage': return `${val}%`
      default: return val.toLocaleString()
    }
  }

  return (
    <div className="w-full">
      <div className="flex items-center gap-2">
        <div className="flex-1 bg-gray-200 rounded-full h-2">
          <div
            className="h-2 rounded-full transition-all"
            style={{
              width: `${Math.min(percentage, 100)}%`,
              backgroundColor: percentage >= 100 ? '#648E8A' : '#15532E'
            }}
          />
        </div>
        <span className="text-sm text-text-secondary whitespace-nowrap">{percentage}%</span>
      </div>
      {currentValue !== undefined && targetValue !== undefined && (
        <div className="text-sm text-text-muted mt-0.5">
          {formatValue(currentValue)} / {formatValue(targetValue)}
        </div>
      )}
    </div>
  )
}
